// eslint-disable-next-line no-unused-vars, import/default
// We need to set the app prefix before doing anything else, so it applies to styles too.
import './webpack-entry';

import Immutable from 'immutable';
import { PluginManifest, PluginStore } from 'graylog-web-plugin/plugin';

import archiveBindings from 'archive/bindings';
import auditlogBindings from 'auditlog/bindings';
import customizationBindings from 'customization/bindings';
import licenseBindings from 'license/bindings';
import reportBindings from 'report/bindings';
import lookupBindings from 'lookup/bindings';
import securityBindings from 'security/bindings';
import authenticationBindings from 'authentication/bindings';
import parameterBindings from 'enterprise/parameters/ParameterBindings';
import eventCorrelationBindings from 'event-correlation/bindings';

import enterpriseMenuBindings from './EnterpriseMenuBindings';

import packageJson from '../../package.json';

const merger = (oldVal, newVal) => oldVal.concat(newVal);
const bindings = Immutable.Map().mergeWith(
  merger,
  archiveBindings,
  auditlogBindings,
  authenticationBindings,
  customizationBindings,
  licenseBindings,
  reportBindings,
  securityBindings,
  enterpriseMenuBindings,
  parameterBindings,
  eventCorrelationBindings,
  lookupBindings,
);
const manifest = new PluginManifest(packageJson, bindings.toJS());

PluginStore.register(manifest);
